const Ke = {
  dev: "https://api-dev.locallogic.co/v3",
  qa: "https://api-qa.locallogic.co/v3",
  prod: "https://api.locallogic.co/v3"
}, Xe = (r, e) => {
  const t = Ke[(e == null ? void 0 : e.environment) || "prod"], n = `${r.substring(0, 3) !== "V3 " ? "V3 " : ""}${r}`;
  async function s(i, a) {
    let u;
    if (a != null && a.params) {
      const o = Object.entries(a.params).filter(([c, d]) => d !== void 0).reduce((c, [d, p]) => (c[d] = p, c), {});
      u = new URLSearchParams({
        ...o,
        /**
         * The "locale" param has been renamed to "language".
         * https://locallogic.atlassian.net/browse/LL22-1220
         */
        ...(e == null ? void 0 : e.locale) && { language: e == null ? void 0 : e.locale }
      });
    } else
      u = new URLSearchParams({
        /**
         * The "locale" param has been renamed to "language".
         * https://locallogic.atlassian.net/browse/LL22-1220
         */
        ...(e == null ? void 0 : e.locale) && { language: e == null ? void 0 : e.locale }
      });
    const l = await fetch(`${t}${i}?${u}`, {
      headers: {
        Accept: "application/json",
        Authorization: n,
        ...(e == null ? void 0 : e.product) && { "x-ll-sdk-name": e.product }
      }
    });
    return l.status === 204 ? {
      data: {},
      meta: {
        message: "Received code 204",
        type: "LocalLogic.API.Success",
        statusCode: 200,
        counts: {}
      }
    } : l.json();
  }
  return {
    get: s
  };
}, he = "/geographies";
function Je(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var re, pe;
function Qe() {
  if (pe) return re;
  pe = 1;
  function r(f) {
    this._maxSize = f, this.clear();
  }
  r.prototype.clear = function() {
    this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
  }, r.prototype.get = function(f) {
    return this._values[f];
  }, r.prototype.set = function(f, g) {
    return this._size >= this._maxSize && this.clear(), f in this._values || this._size++, this._values[f] = g;
  };
  var e = /[^.^\]^[]+|(?=\[\]|\.\.)/g, t = /^\d+$/, n = /^\d/, s = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, i = /^\s*(['"]?)(.*?)(\1)\s*$/, a = 512, u = new r(a), l = new r(a), o = new r(a);
  re = {
    Cache: r,
    split: d,
    normalizePath: c,
    setter: function(f) {
      var g = c(f);
      return l.get(f) || l.set(f, function(j, x) {
        for (var v = 0, C = g.length, V = j; v < C - 1; ) {
          var U = g[v];
          if (U === "__proto__" || U === "constructor" || U === "prototype")
            return j;
          V = V[g[v++]];
        }
        V[g[v]] = x;
      });
    },
    getter: function(f, g) {
      var T = c(f);
      return o.get(f) || o.set(f, function(x) {
        for (var v = 0, C = T.length; v < C; )
          if (x != null || !g) x = x[T[v++]];
          else return;
        return x;
      });
    },
    join: function(f) {
      return f.reduce(function(g, T) {
        return g + (m(T) || t.test(T) ? "[" + T + "]" : (g ? "." : "") + T);
      }, "");
    },
    forEach: function(f, g, T) {
      p(Array.isArray(f) ? f : d(f), g, T);
    }
  };
  function c(f) {
    return u.get(f) || u.set(
      f,
      d(f).map(function(g) {
        return g.replace(i, "$2");
      })
    );
  }
  function d(f) {
    return f.match(e) || [""];
  }
  function p(f, g, T) {
    var j = f.length, x, v, C, V;
    for (v = 0; v < j; v++)
      x = f[v], x && (S(x) && (x = '"' + x + '"'), V = m(x), C = !V && /^\d+$/.test(x), g.call(T, x, V, C, v, f));
  }
  function m(f) {
    return typeof f == "string" && f && ["'", '"'].indexOf(f.charAt(0)) !== -1;
  }
  function w(f) {
    return f.match(n) && !f.match(t);
  }
  function _(f) {
    return s.test(f);
  }
  function S(f) {
    return !m(f) && (w(f) || _(f));
  }
  return re;
}
var H = Qe(), ne, me;
function We() {
  if (me) return ne;
  me = 1;
  const r = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g, e = (c) => c.match(r) || [], t = (c) => c[0].toUpperCase() + c.slice(1), n = (c, d) => e(c).join(d).toLowerCase(), s = (c) => e(c).reduce(
    (d, p) => `${d}${d ? p[0].toUpperCase() + p.slice(1).toLowerCase() : p.toLowerCase()}`,
    ""
  );
  return ne = {
    words: e,
    upperFirst: t,
    camelCase: s,
    pascalCase: (c) => t(s(c)),
    snakeCase: (c) => n(c, "_"),
    kebabCase: (c) => n(c, "-"),
    sentenceCase: (c) => t(n(c, " ")),
    titleCase: (c) => e(c).map(t).join(" ")
  }, ne;
}
var se = We(), Y = { exports: {} }, ye;
function et() {
  if (ye) return Y.exports;
  ye = 1, Y.exports = function(s) {
    return r(e(s), s);
  }, Y.exports.array = r;
  function r(s, i) {
    var a = s.length, u = new Array(a), l = {}, o = a, c = t(i), d = n(s);
    for (i.forEach(function(m) {
      if (!d.has(m[0]) || !d.has(m[1]))
        throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    }); o--; )
      l[o] || p(s[o], o, /* @__PURE__ */ new Set());
    return u;
    function p(m, w, _) {
      if (_.has(m)) {
        var S;
        try {
          S = ", node was:" + JSON.stringify(m);
        } catch {
          S = "";
        }
        throw new Error("Cyclic dependency" + S);
      }
      if (!d.has(m))
        throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(m));
      if (!l[w]) {
        l[w] = !0;
        var f = c.get(m) || /* @__PURE__ */ new Set();
        if (f = Array.from(f), w = f.length) {
          _.add(m);
          do {
            var g = f[--w];
            p(g, d.get(g), _);
          } while (w);
          _.delete(m);
        }
        u[--a] = m;
      }
    }
  }
  function e(s) {
    for (var i = /* @__PURE__ */ new Set(), a = 0, u = s.length; a < u; a++) {
      var l = s[a];
      i.add(l[0]), i.add(l[1]);
    }
    return Array.from(i);
  }
  function t(s) {
    for (var i = /* @__PURE__ */ new Map(), a = 0, u = s.length; a < u; a++) {
      var l = s[a];
      i.has(l[0]) || i.set(l[0], /* @__PURE__ */ new Set()), i.has(l[1]) || i.set(l[1], /* @__PURE__ */ new Set()), i.get(l[0]).add(l[1]);
    }
    return i;
  }
  function n(s) {
    for (var i = /* @__PURE__ */ new Map(), a = 0, u = s.length; a < u; a++)
      i.set(s[a], a);
    return i;
  }
  return Y.exports;
}
var tt = et();
const rt = /* @__PURE__ */ Je(tt), nt = Object.prototype.toString, st = Error.prototype.toString, it = RegExp.prototype.toString, at = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", ut = /^Symbol\((.*)\)(.*)$/;
function lt(r) {
  return r != +r ? "NaN" : r === 0 && 1 / r < 0 ? "-0" : "" + r;
}
function ge(r, e = !1) {
  if (r == null || r === !0 || r === !1) return "" + r;
  const t = typeof r;
  if (t === "number") return lt(r);
  if (t === "string") return e ? `"${r}"` : r;
  if (t === "function") return "[Function " + (r.name || "anonymous") + "]";
  if (t === "symbol") return at.call(r).replace(ut, "Symbol($1)");
  const n = nt.call(r).slice(8, -1);
  return n === "Date" ? isNaN(r.getTime()) ? "" + r : r.toISOString(r) : n === "Error" || r instanceof Error ? "[" + st.call(r) + "]" : n === "RegExp" ? it.call(r) : null;
}
function L(r, e) {
  let t = ge(r, e);
  return t !== null ? t : JSON.stringify(r, function(n, s) {
    let i = ge(this[n], e);
    return i !== null ? i : s;
  }, 2);
}
function Se(r) {
  return r == null ? [] : [].concat(r);
}
let Fe, Ae, ke, ot = /\$\{\s*(\w+)\s*\}/g;
Fe = Symbol.toStringTag;
class be {
  constructor(e, t, n, s) {
    this.name = void 0, this.message = void 0, this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = void 0, this.inner = void 0, this[Fe] = "Error", this.name = "ValidationError", this.value = t, this.path = n, this.type = s, this.errors = [], this.inner = [], Se(e).forEach((i) => {
      if (A.isError(i)) {
        this.errors.push(...i.errors);
        const a = i.inner.length ? i.inner : [i];
        this.inner.push(...a);
      } else
        this.errors.push(i);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
  }
}
Ae = Symbol.hasInstance;
ke = Symbol.toStringTag;
let A = class Re extends Error {
  static formatError(e, t) {
    const n = t.label || t.path || "this";
    return t = Object.assign({}, t, {
      path: n,
      originalPath: t.path
    }), typeof e == "string" ? e.replace(ot, (s, i) => L(t[i])) : typeof e == "function" ? e(t) : e;
  }
  static isError(e) {
    return e && e.name === "ValidationError";
  }
  constructor(e, t, n, s, i) {
    const a = new be(e, t, n, s);
    if (i)
      return a;
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = [], this.inner = [], this[ke] = "Error", this.name = a.name, this.message = a.message, this.type = a.type, this.value = a.value, this.path = a.path, this.errors = a.errors, this.inner = a.inner, Error.captureStackTrace && Error.captureStackTrace(this, Re);
  }
  static [Ae](e) {
    return be[Symbol.hasInstance](e) || super[Symbol.hasInstance](e);
  }
}, D = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  defined: "${path} must be defined",
  notNull: "${path} cannot be null",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: r,
    type: e,
    value: t,
    originalValue: n
  }) => {
    const s = n != null && n !== t ? ` (cast from the value \`${L(n, !0)}\`).` : ".";
    return e !== "mixed" ? `${r} must be a \`${e}\` type, but the final value was: \`${L(t, !0)}\`` + s : `${r} must match the configured type. The validated value was: \`${L(t, !0)}\`` + s;
  }
}, F = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  datetime: "${path} must be a valid ISO date-time",
  datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, z = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, ie = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, ae = {
  isValue: "${path} field must be ${value}"
}, X = {
  noUnknown: "${path} field has unspecified keys: ${unknown}",
  exact: "${path} object contains unknown properties: ${properties}"
}, J = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
}, ct = {
  notType: (r) => {
    const {
      path: e,
      value: t,
      spec: n
    } = r, s = n.types.length;
    if (Array.isArray(t)) {
      if (t.length < s) return `${e} tuple value has too few items, expected a length of ${s} but got ${t.length} for value: \`${L(t, !0)}\``;
      if (t.length > s) return `${e} tuple value has too many items, expected a length of ${s} but got ${t.length} for value: \`${L(t, !0)}\``;
    }
    return A.formatError(D.notType, r);
  }
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: D,
  string: F,
  number: z,
  date: ie,
  object: X,
  array: J,
  boolean: ae,
  tuple: ct
});
const te = (r) => r && r.__isYupSchema__;
class W {
  static fromOptions(e, t) {
    if (!t.then && !t.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: n,
      then: s,
      otherwise: i
    } = t, a = typeof n == "function" ? n : (...u) => u.every((l) => l === n);
    return new W(e, (u, l) => {
      var o;
      let c = a(...u) ? s : i;
      return (o = c == null ? void 0 : c(l)) != null ? o : l;
    });
  }
  constructor(e, t) {
    this.fn = void 0, this.refs = e, this.refs = e, this.fn = t;
  }
  resolve(e, t) {
    let n = this.refs.map((i) => (
      // TODO: ? operator here?
      i.getValue(t == null ? void 0 : t.value, t == null ? void 0 : t.parent, t == null ? void 0 : t.context)
    )), s = this.fn(n, e, t);
    if (s === void 0 || // @ts-ignore this can be base
    s === e)
      return e;
    if (!te(s)) throw new TypeError("conditions must return a schema object");
    return s.resolve(t);
  }
}
const K = {
  context: "$",
  value: "."
};
class G {
  constructor(e, t = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof e != "string") throw new TypeError("ref must be a string, got: " + e);
    if (this.key = e.trim(), e === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === K.context, this.isValue = this.key[0] === K.value, this.isSibling = !this.isContext && !this.isValue;
    let n = this.isContext ? K.context : this.isValue ? K.value : "";
    this.path = this.key.slice(n.length), this.getter = this.path && H.getter(this.path, !0), this.map = t.map;
  }
  getValue(e, t, n) {
    let s = this.isContext ? n : this.isValue ? e : t;
    return this.getter && (s = this.getter(s || {})), this.map && (s = this.map(s)), s;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(e, t) {
    return this.getValue(e, t == null ? void 0 : t.parent, t == null ? void 0 : t.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(e) {
    return e && e.__isYupRef;
  }
}
G.prototype.__isYupRef = !0;
const N = (r) => r == null;
function Z(r) {
  function e({
    value: t,
    path: n = "",
    options: s,
    originalValue: i,
    schema: a
  }, u, l) {
    const {
      name: o,
      test: c,
      params: d,
      message: p,
      skipAbsent: m
    } = r;
    let {
      parent: w,
      context: _,
      abortEarly: S = a.spec.abortEarly,
      disableStackTrace: f = a.spec.disableStackTrace
    } = s;
    const g = {
      value: t,
      parent: w,
      context: _
    };
    function T(E = {}) {
      const B = Oe(Object.assign({
        value: t,
        originalValue: i,
        label: a.spec.label,
        path: E.path || n,
        spec: a.spec,
        disableStackTrace: E.disableStackTrace || f
      }, d, E.params), g), fe = new A(A.formatError(E.message || p, B), t, B.path, E.type || o, B.disableStackTrace);
      return fe.params = B, fe;
    }
    const j = S ? u : l;
    let x = {
      path: n,
      parent: w,
      type: o,
      from: s.from,
      createError: T,
      resolve(E) {
        return Me(E, g);
      },
      options: s,
      originalValue: i,
      schema: a
    };
    const v = (E) => {
      A.isError(E) ? j(E) : E ? l(null) : j(T());
    }, C = (E) => {
      A.isError(E) ? j(E) : u(E);
    };
    if (m && N(t))
      return v(!0);
    let U;
    try {
      var de;
      if (U = c.call(x, t, x), typeof ((de = U) == null ? void 0 : de.then) == "function") {
        if (s.sync)
          throw new Error(`Validation test of type: "${x.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
        return Promise.resolve(U).then(v, C);
      }
    } catch (E) {
      C(E);
      return;
    }
    v(U);
  }
  return e.OPTIONS = r, e;
}
function Oe(r, e) {
  if (!r) return r;
  for (const t of Object.keys(r))
    r[t] = Me(r[t], e);
  return r;
}
function Me(r, e) {
  return G.isRef(r) ? r.getValue(e.value, e.parent, e.context) : r;
}
function dt(r, e, t, n = t) {
  let s, i, a;
  return e ? (H.forEach(e, (u, l, o) => {
    let c = l ? u.slice(1, u.length - 1) : u;
    r = r.resolve({
      context: n,
      parent: s,
      value: t
    });
    let d = r.type === "tuple", p = o ? parseInt(c, 10) : 0;
    if (r.innerType || d) {
      if (d && !o) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${a}" must contain an index to the tuple element, e.g. "${a}[0]"`);
      if (t && p >= t.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${u}, in the path: ${e}. because there is no value at that index. `);
      s = t, t = t && t[p], r = d ? r.spec.types[p] : r.innerType;
    }
    if (!o) {
      if (!r.fields || !r.fields[c]) throw new Error(`The schema does not contain the path: ${e}. (failed at: ${a} which is a type: "${r.type}")`);
      s = t, t = t && t[c], r = r.fields[c];
    }
    i = c, a = l ? "[" + u + "]" : "." + u;
  }), {
    schema: r,
    parent: s,
    parentPath: i
  }) : {
    parent: s,
    parentPath: e,
    schema: r
  };
}
class ee extends Set {
  describe() {
    const e = [];
    for (const t of this.values())
      e.push(G.isRef(t) ? t.describe() : t);
    return e;
  }
  resolveAll(e) {
    let t = [];
    for (const n of this.values())
      t.push(e(n));
    return t;
  }
  clone() {
    return new ee(this.values());
  }
  merge(e, t) {
    const n = this.clone();
    return e.forEach((s) => n.add(s)), t.forEach((s) => n.delete(s)), n;
  }
}
function P(r, e = /* @__PURE__ */ new Map()) {
  if (te(r) || !r || typeof r != "object") return r;
  if (e.has(r)) return e.get(r);
  let t;
  if (r instanceof Date)
    t = new Date(r.getTime()), e.set(r, t);
  else if (r instanceof RegExp)
    t = new RegExp(r), e.set(r, t);
  else if (Array.isArray(r)) {
    t = new Array(r.length), e.set(r, t);
    for (let n = 0; n < r.length; n++) t[n] = P(r[n], e);
  } else if (r instanceof Map) {
    t = /* @__PURE__ */ new Map(), e.set(r, t);
    for (const [n, s] of r.entries()) t.set(n, P(s, e));
  } else if (r instanceof Set) {
    t = /* @__PURE__ */ new Set(), e.set(r, t);
    for (const n of r) t.add(P(n, e));
  } else if (r instanceof Object) {
    t = {}, e.set(r, t);
    for (const [n, s] of Object.entries(r)) t[n] = P(s, e);
  } else
    throw Error(`Unable to clone ${r}`);
  return t;
}
function ft(r) {
  if (!(r != null && r.length))
    return;
  const e = [];
  let t = "", n = !1, s = !1;
  for (let i = 0; i < r.length; i++) {
    const a = r[i];
    if (a === "[" && !s) {
      t && (e.push(...t.split(".").filter(Boolean)), t = ""), n = !0;
      continue;
    }
    if (a === "]" && !s) {
      t && (/^\d+$/.test(t) ? e.push(t) : e.push(t.replace(/^"|"$/g, "")), t = ""), n = !1;
      continue;
    }
    if (a === '"') {
      s = !s;
      continue;
    }
    if (a === "." && !n && !s) {
      t && (e.push(t), t = "");
      continue;
    }
    t += a;
  }
  return t && e.push(...t.split(".").filter(Boolean)), e;
}
function ht(r, e) {
  const t = e ? `${e}.${r.path}` : r.path;
  return r.errors.map((n) => ({
    message: n,
    path: ft(t)
  }));
}
function Ne(r, e) {
  var t;
  if (!((t = r.inner) != null && t.length) && r.errors.length)
    return ht(r, e);
  const n = e ? `${e}.${r.path}` : r.path;
  return r.inner.flatMap((s) => Ne(s, n));
}
class M {
  constructor(e) {
    this.type = void 0, this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this.internalTests = {}, this._whitelist = new ee(), this._blacklist = new ee(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this._typeCheck = void 0, this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(D.notType);
    }), this.type = e.type, this._typeCheck = e.check, this.spec = Object.assign({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      disableStackTrace: !1,
      nullable: !1,
      optional: !0,
      coerce: !0
    }, e == null ? void 0 : e.spec), this.withMutation((t) => {
      t.nonNullable();
    });
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(e) {
    if (this._mutate)
      return e && Object.assign(this.spec, e), this;
    const t = Object.create(Object.getPrototypeOf(this));
    return t.type = this.type, t._typeCheck = this._typeCheck, t._whitelist = this._whitelist.clone(), t._blacklist = this._blacklist.clone(), t.internalTests = Object.assign({}, this.internalTests), t.exclusiveTests = Object.assign({}, this.exclusiveTests), t.deps = [...this.deps], t.conditions = [...this.conditions], t.tests = [...this.tests], t.transforms = [...this.transforms], t.spec = P(Object.assign({}, this.spec, e)), t;
  }
  label(e) {
    let t = this.clone();
    return t.spec.label = e, t;
  }
  meta(...e) {
    if (e.length === 0) return this.spec.meta;
    let t = this.clone();
    return t.spec.meta = Object.assign(t.spec.meta || {}, e[0]), t;
  }
  withMutation(e) {
    let t = this._mutate;
    this._mutate = !0;
    let n = e(this);
    return this._mutate = t, n;
  }
  concat(e) {
    if (!e || e === this) return this;
    if (e.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${e.type}`);
    let t = this, n = e.clone();
    const s = Object.assign({}, t.spec, n.spec);
    return n.spec = s, n.internalTests = Object.assign({}, t.internalTests, n.internalTests), n._whitelist = t._whitelist.merge(e._whitelist, e._blacklist), n._blacklist = t._blacklist.merge(e._blacklist, e._whitelist), n.tests = t.tests, n.exclusiveTests = t.exclusiveTests, n.withMutation((i) => {
      e.tests.forEach((a) => {
        i.test(a.OPTIONS);
      });
    }), n.transforms = [...t.transforms, ...n.transforms], n;
  }
  isType(e) {
    return e == null ? !!(this.spec.nullable && e === null || this.spec.optional && e === void 0) : this._typeCheck(e);
  }
  resolve(e) {
    let t = this;
    if (t.conditions.length) {
      let n = t.conditions;
      t = t.clone(), t.conditions = [], t = n.reduce((s, i) => i.resolve(s, e), t), t = t.resolve(e);
    }
    return t;
  }
  resolveOptions(e) {
    var t, n, s, i;
    return Object.assign({}, e, {
      from: e.from || [],
      strict: (t = e.strict) != null ? t : this.spec.strict,
      abortEarly: (n = e.abortEarly) != null ? n : this.spec.abortEarly,
      recursive: (s = e.recursive) != null ? s : this.spec.recursive,
      disableStackTrace: (i = e.disableStackTrace) != null ? i : this.spec.disableStackTrace
    });
  }
  /**
   * Run the configured transform pipeline over an input value.
   */
  cast(e, t = {}) {
    let n = this.resolve(Object.assign({
      value: e
    }, t)), s = t.assert === "ignore-optionality", i = n._cast(e, t);
    if (t.assert !== !1 && !n.isType(i)) {
      if (s && N(i))
        return i;
      let a = L(e), u = L(i);
      throw new TypeError(`The value of ${t.path || "field"} could not be cast to a value that satisfies the schema type: "${n.type}". 

attempted value: ${a} 
` + (u !== a ? `result of cast: ${u}` : ""));
    }
    return i;
  }
  _cast(e, t) {
    let n = e === void 0 ? e : this.transforms.reduce((s, i) => i.call(this, s, e, this), e);
    return n === void 0 && (n = this.getDefault(t)), n;
  }
  _validate(e, t = {}, n, s) {
    let {
      path: i,
      originalValue: a = e,
      strict: u = this.spec.strict
    } = t, l = e;
    u || (l = this._cast(l, Object.assign({
      assert: !1
    }, t)));
    let o = [];
    for (let c of Object.values(this.internalTests))
      c && o.push(c);
    this.runTests({
      path: i,
      value: l,
      originalValue: a,
      options: t,
      tests: o
    }, n, (c) => {
      if (c.length)
        return s(c, l);
      this.runTests({
        path: i,
        value: l,
        originalValue: a,
        options: t,
        tests: this.tests
      }, n, s);
    });
  }
  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(e, t, n) {
    let s = !1, {
      tests: i,
      value: a,
      originalValue: u,
      path: l,
      options: o
    } = e, c = (_) => {
      s || (s = !0, t(_, a));
    }, d = (_) => {
      s || (s = !0, n(_, a));
    }, p = i.length, m = [];
    if (!p) return d([]);
    let w = {
      value: a,
      originalValue: u,
      path: l,
      options: o,
      schema: this
    };
    for (let _ = 0; _ < i.length; _++) {
      const S = i[_];
      S(w, c, function(g) {
        g && (Array.isArray(g) ? m.push(...g) : m.push(g)), --p <= 0 && d(m);
      });
    }
  }
  asNestedTest({
    key: e,
    index: t,
    parent: n,
    parentPath: s,
    originalParent: i,
    options: a
  }) {
    const u = e ?? t;
    if (u == null)
      throw TypeError("Must include `key` or `index` for nested validations");
    const l = typeof u == "number";
    let o = n[u];
    const c = Object.assign({}, a, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: !0,
      parent: n,
      value: o,
      originalValue: i[u],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: void 0,
      // index: undefined,
      [l ? "index" : "key"]: u,
      path: l || u.includes(".") ? `${s || ""}[${l ? u : `"${u}"`}]` : (s ? `${s}.` : "") + e
    });
    return (d, p, m) => this.resolve(c)._validate(o, c, p, m);
  }
  validate(e, t) {
    var n;
    let s = this.resolve(Object.assign({}, t, {
      value: e
    })), i = (n = t == null ? void 0 : t.disableStackTrace) != null ? n : s.spec.disableStackTrace;
    return new Promise((a, u) => s._validate(e, t, (l, o) => {
      A.isError(l) && (l.value = o), u(l);
    }, (l, o) => {
      l.length ? u(new A(l, o, void 0, void 0, i)) : a(o);
    }));
  }
  validateSync(e, t) {
    var n;
    let s = this.resolve(Object.assign({}, t, {
      value: e
    })), i, a = (n = t == null ? void 0 : t.disableStackTrace) != null ? n : s.spec.disableStackTrace;
    return s._validate(e, Object.assign({}, t, {
      sync: !0
    }), (u, l) => {
      throw A.isError(u) && (u.value = l), u;
    }, (u, l) => {
      if (u.length) throw new A(u, e, void 0, void 0, a);
      i = l;
    }), i;
  }
  isValid(e, t) {
    return this.validate(e, t).then(() => !0, (n) => {
      if (A.isError(n)) return !1;
      throw n;
    });
  }
  isValidSync(e, t) {
    try {
      return this.validateSync(e, t), !0;
    } catch (n) {
      if (A.isError(n)) return !1;
      throw n;
    }
  }
  _getDefault(e) {
    let t = this.spec.default;
    return t == null ? t : typeof t == "function" ? t.call(this, e) : P(t);
  }
  getDefault(e) {
    return this.resolve(e || {})._getDefault(e);
  }
  default(e) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: e
    });
  }
  strict(e = !0) {
    return this.clone({
      strict: e
    });
  }
  nullability(e, t) {
    const n = this.clone({
      nullable: e
    });
    return n.internalTests.nullable = Z({
      message: t,
      name: "nullable",
      test(s) {
        return s === null ? this.schema.spec.nullable : !0;
      }
    }), n;
  }
  optionality(e, t) {
    const n = this.clone({
      optional: e
    });
    return n.internalTests.optionality = Z({
      message: t,
      name: "optionality",
      test(s) {
        return s === void 0 ? this.schema.spec.optional : !0;
      }
    }), n;
  }
  optional() {
    return this.optionality(!0);
  }
  defined(e = D.defined) {
    return this.optionality(!1, e);
  }
  nullable() {
    return this.nullability(!0);
  }
  nonNullable(e = D.notNull) {
    return this.nullability(!1, e);
  }
  required(e = D.required) {
    return this.clone().withMutation((t) => t.nonNullable(e).defined(e));
  }
  notRequired() {
    return this.clone().withMutation((e) => e.nullable().optional());
  }
  transform(e) {
    let t = this.clone();
    return t.transforms.push(e), t;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...e) {
    let t;
    if (e.length === 1 ? typeof e[0] == "function" ? t = {
      test: e[0]
    } : t = e[0] : e.length === 2 ? t = {
      name: e[0],
      test: e[1]
    } : t = {
      name: e[0],
      message: e[1],
      test: e[2]
    }, t.message === void 0 && (t.message = D.default), typeof t.test != "function") throw new TypeError("`test` is a required parameters");
    let n = this.clone(), s = Z(t), i = t.exclusive || t.name && n.exclusiveTests[t.name] === !0;
    if (t.exclusive && !t.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return t.name && (n.exclusiveTests[t.name] = !!t.exclusive), n.tests = n.tests.filter((a) => !(a.OPTIONS.name === t.name && (i || a.OPTIONS.test === s.OPTIONS.test))), n.tests.push(s), n;
  }
  when(e, t) {
    !Array.isArray(e) && typeof e != "string" && (t = e, e = ".");
    let n = this.clone(), s = Se(e).map((i) => new G(i));
    return s.forEach((i) => {
      i.isSibling && n.deps.push(i.key);
    }), n.conditions.push(typeof t == "function" ? new W(s, t) : W.fromOptions(s, t)), n;
  }
  typeError(e) {
    let t = this.clone();
    return t.internalTests.typeError = Z({
      message: e,
      name: "typeError",
      skipAbsent: !0,
      test(n) {
        return this.schema._typeCheck(n) ? !0 : this.createError({
          params: {
            type: this.schema.type
          }
        });
      }
    }), t;
  }
  oneOf(e, t = D.oneOf) {
    let n = this.clone();
    return e.forEach((s) => {
      n._whitelist.add(s), n._blacklist.delete(s);
    }), n.internalTests.whiteList = Z({
      message: t,
      name: "oneOf",
      skipAbsent: !0,
      test(s) {
        let i = this.schema._whitelist, a = i.resolveAll(this.resolve);
        return a.includes(s) ? !0 : this.createError({
          params: {
            values: Array.from(i).join(", "),
            resolved: a
          }
        });
      }
    }), n;
  }
  notOneOf(e, t = D.notOneOf) {
    let n = this.clone();
    return e.forEach((s) => {
      n._blacklist.add(s), n._whitelist.delete(s);
    }), n.internalTests.blacklist = Z({
      message: t,
      name: "notOneOf",
      test(s) {
        let i = this.schema._blacklist, a = i.resolveAll(this.resolve);
        return a.includes(s) ? this.createError({
          params: {
            values: Array.from(i).join(", "),
            resolved: a
          }
        }) : !0;
      }
    }), n;
  }
  strip(e = !0) {
    let t = this.clone();
    return t.spec.strip = e, t;
  }
  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(e) {
    const t = (e ? this.resolve(e) : this).clone(), {
      label: n,
      meta: s,
      optional: i,
      nullable: a
    } = t.spec;
    return {
      meta: s,
      label: n,
      optional: i,
      nullable: a,
      default: t.getDefault(e),
      type: t.type,
      oneOf: t._whitelist.describe(),
      notOneOf: t._blacklist.describe(),
      tests: t.tests.filter((l, o, c) => c.findIndex((d) => d.OPTIONS.name === l.OPTIONS.name) === o).map((l) => {
        const o = l.OPTIONS.params && e ? Oe(Object.assign({}, l.OPTIONS.params), e) : l.OPTIONS.params;
        return {
          name: l.OPTIONS.name,
          params: o
        };
      })
    };
  }
  get "~standard"() {
    const e = this;
    return {
      version: 1,
      vendor: "yup",
      async validate(n) {
        try {
          return {
            value: await e.validate(n, {
              abortEarly: !1
            })
          };
        } catch (s) {
          if (s instanceof A)
            return {
              issues: Ne(s)
            };
          throw s;
        }
      }
    };
  }
}
M.prototype.__isYupSchema__ = !0;
for (const r of ["validate", "validateSync"]) M.prototype[`${r}At`] = function(e, t, n = {}) {
  const {
    parent: s,
    parentPath: i,
    schema: a
  } = dt(this, e, t, n.context);
  return a[r](s && s[i], Object.assign({}, n, {
    parent: s,
    path: e
  }));
};
for (const r of ["equals", "is"]) M.prototype[r] = M.prototype.oneOf;
for (const r of ["not", "nope"]) M.prototype[r] = M.prototype.notOneOf;
function oe() {
  return new De();
}
class De extends M {
  constructor() {
    super({
      type: "boolean",
      check(e) {
        return e instanceof Boolean && (e = e.valueOf()), typeof e == "boolean";
      }
    }), this.withMutation(() => {
      this.transform((e, t, n) => {
        if (n.spec.coerce && !n.isType(e)) {
          if (/^(true|1)$/i.test(String(e))) return !0;
          if (/^(false|0)$/i.test(String(e))) return !1;
        }
        return e;
      });
    });
  }
  isTrue(e = ae.isValue) {
    return this.test({
      message: e,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "true"
      },
      test(t) {
        return N(t) || t === !0;
      }
    });
  }
  isFalse(e = ae.isValue) {
    return this.test({
      message: e,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "false"
      },
      test(t) {
        return N(t) || t === !1;
      }
    });
  }
  default(e) {
    return super.default(e);
  }
  defined(e) {
    return super.defined(e);
  }
  optional() {
    return super.optional();
  }
  required(e) {
    return super.required(e);
  }
  notRequired() {
    return super.notRequired();
  }
  nullable() {
    return super.nullable();
  }
  nonNullable(e) {
    return super.nonNullable(e);
  }
  strip(e) {
    return super.strip(e);
  }
}
oe.prototype = De.prototype;
const pt = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function mt(r) {
  const e = ue(r);
  if (!e) return Date.parse ? Date.parse(r) : Number.NaN;
  if (e.z === void 0 && e.plusMinus === void 0)
    return new Date(e.year, e.month, e.day, e.hour, e.minute, e.second, e.millisecond).valueOf();
  let t = 0;
  return e.z !== "Z" && e.plusMinus !== void 0 && (t = e.hourOffset * 60 + e.minuteOffset, e.plusMinus === "+" && (t = 0 - t)), Date.UTC(e.year, e.month, e.day, e.hour, e.minute + t, e.second, e.millisecond);
}
function ue(r) {
  var e, t;
  const n = pt.exec(r);
  return n ? {
    year: q(n[1]),
    month: q(n[2], 1) - 1,
    day: q(n[3], 1),
    hour: q(n[4]),
    minute: q(n[5]),
    second: q(n[6]),
    millisecond: n[7] ? (
      // allow arbitrary sub-second precision beyond milliseconds
      q(n[7].substring(0, 3))
    ) : 0,
    precision: (e = (t = n[7]) == null ? void 0 : t.length) != null ? e : void 0,
    z: n[8] || void 0,
    plusMinus: n[9] || void 0,
    hourOffset: q(n[10]),
    minuteOffset: q(n[11])
  } : null;
}
function q(r, e = 0) {
  return Number(r) || e;
}
let yt = (
  // eslint-disable-next-line
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
), gt = (
  // eslint-disable-next-line
  /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
), bt = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, xt = "^\\d{4}-\\d{2}-\\d{2}", _t = "\\d{2}:\\d{2}:\\d{2}", vt = "(([+-]\\d{2}(:?\\d{2})?)|Z)", Et = new RegExp(`${xt}T${_t}(\\.\\d+)?${vt}$`), wt = (r) => N(r) || r === r.trim(), Tt = {}.toString();
function b() {
  return new je();
}
class je extends M {
  constructor() {
    super({
      type: "string",
      check(e) {
        return e instanceof String && (e = e.valueOf()), typeof e == "string";
      }
    }), this.withMutation(() => {
      this.transform((e, t, n) => {
        if (!n.spec.coerce || n.isType(e) || Array.isArray(e)) return e;
        const s = e != null && e.toString ? e.toString() : e;
        return s === Tt ? e : s;
      });
    });
  }
  required(e) {
    return super.required(e).withMutation((t) => t.test({
      message: e || D.required,
      name: "required",
      skipAbsent: !0,
      test: (n) => !!n.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation((e) => (e.tests = e.tests.filter((t) => t.OPTIONS.name !== "required"), e));
  }
  length(e, t = F.length) {
    return this.test({
      message: t,
      name: "length",
      exclusive: !0,
      params: {
        length: e
      },
      skipAbsent: !0,
      test(n) {
        return n.length === this.resolve(e);
      }
    });
  }
  min(e, t = F.min) {
    return this.test({
      message: t,
      name: "min",
      exclusive: !0,
      params: {
        min: e
      },
      skipAbsent: !0,
      test(n) {
        return n.length >= this.resolve(e);
      }
    });
  }
  max(e, t = F.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: t,
      params: {
        max: e
      },
      skipAbsent: !0,
      test(n) {
        return n.length <= this.resolve(e);
      }
    });
  }
  matches(e, t) {
    let n = !1, s, i;
    return t && (typeof t == "object" ? {
      excludeEmptyString: n = !1,
      message: s,
      name: i
    } = t : s = t), this.test({
      name: i || "matches",
      message: s || F.matches,
      params: {
        regex: e
      },
      skipAbsent: !0,
      test: (a) => a === "" && n || a.search(e) !== -1
    });
  }
  email(e = F.email) {
    return this.matches(yt, {
      name: "email",
      message: e,
      excludeEmptyString: !0
    });
  }
  url(e = F.url) {
    return this.matches(gt, {
      name: "url",
      message: e,
      excludeEmptyString: !0
    });
  }
  uuid(e = F.uuid) {
    return this.matches(bt, {
      name: "uuid",
      message: e,
      excludeEmptyString: !1
    });
  }
  datetime(e) {
    let t = "", n, s;
    return e && (typeof e == "object" ? {
      message: t = "",
      allowOffset: n = !1,
      precision: s = void 0
    } = e : t = e), this.matches(Et, {
      name: "datetime",
      message: t || F.datetime,
      excludeEmptyString: !0
    }).test({
      name: "datetime_offset",
      message: t || F.datetime_offset,
      params: {
        allowOffset: n
      },
      skipAbsent: !0,
      test: (i) => {
        if (!i || n) return !0;
        const a = ue(i);
        return a ? !!a.z : !1;
      }
    }).test({
      name: "datetime_precision",
      message: t || F.datetime_precision,
      params: {
        precision: s
      },
      skipAbsent: !0,
      test: (i) => {
        if (!i || s == null) return !0;
        const a = ue(i);
        return a ? a.precision === s : !1;
      }
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((e) => e === null ? "" : e);
  }
  trim(e = F.trim) {
    return this.transform((t) => t != null ? t.trim() : t).test({
      message: e,
      name: "trim",
      test: wt
    });
  }
  lowercase(e = F.lowercase) {
    return this.transform((t) => N(t) ? t : t.toLowerCase()).test({
      message: e,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (t) => N(t) || t === t.toLowerCase()
    });
  }
  uppercase(e = F.uppercase) {
    return this.transform((t) => N(t) ? t : t.toUpperCase()).test({
      message: e,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (t) => N(t) || t === t.toUpperCase()
    });
  }
}
b.prototype = je.prototype;
let $t = (r) => r != +r;
function y() {
  return new Ce();
}
class Ce extends M {
  constructor() {
    super({
      type: "number",
      check(e) {
        return e instanceof Number && (e = e.valueOf()), typeof e == "number" && !$t(e);
      }
    }), this.withMutation(() => {
      this.transform((e, t, n) => {
        if (!n.spec.coerce) return e;
        let s = e;
        if (typeof s == "string") {
          if (s = s.replace(/\s/g, ""), s === "") return NaN;
          s = +s;
        }
        return n.isType(s) || s === null ? s : parseFloat(s);
      });
    });
  }
  min(e, t = z.min) {
    return this.test({
      message: t,
      name: "min",
      exclusive: !0,
      params: {
        min: e
      },
      skipAbsent: !0,
      test(n) {
        return n >= this.resolve(e);
      }
    });
  }
  max(e, t = z.max) {
    return this.test({
      message: t,
      name: "max",
      exclusive: !0,
      params: {
        max: e
      },
      skipAbsent: !0,
      test(n) {
        return n <= this.resolve(e);
      }
    });
  }
  lessThan(e, t = z.lessThan) {
    return this.test({
      message: t,
      name: "max",
      exclusive: !0,
      params: {
        less: e
      },
      skipAbsent: !0,
      test(n) {
        return n < this.resolve(e);
      }
    });
  }
  moreThan(e, t = z.moreThan) {
    return this.test({
      message: t,
      name: "min",
      exclusive: !0,
      params: {
        more: e
      },
      skipAbsent: !0,
      test(n) {
        return n > this.resolve(e);
      }
    });
  }
  positive(e = z.positive) {
    return this.moreThan(0, e);
  }
  negative(e = z.negative) {
    return this.lessThan(0, e);
  }
  integer(e = z.integer) {
    return this.test({
      name: "integer",
      message: e,
      skipAbsent: !0,
      test: (t) => Number.isInteger(t)
    });
  }
  truncate() {
    return this.transform((e) => N(e) ? e : e | 0);
  }
  round(e) {
    var t;
    let n = ["ceil", "floor", "round", "trunc"];
    if (e = ((t = e) == null ? void 0 : t.toLowerCase()) || "round", e === "trunc") return this.truncate();
    if (n.indexOf(e.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + n.join(", "));
    return this.transform((s) => N(s) ? s : Math[e](s));
  }
}
y.prototype = Ce.prototype;
let St = /* @__PURE__ */ new Date(""), Ft = (r) => Object.prototype.toString.call(r) === "[object Date]";
class ce extends M {
  constructor() {
    super({
      type: "date",
      check(e) {
        return Ft(e) && !isNaN(e.getTime());
      }
    }), this.withMutation(() => {
      this.transform((e, t, n) => !n.spec.coerce || n.isType(e) || e === null ? e : (e = mt(e), isNaN(e) ? ce.INVALID_DATE : new Date(e)));
    });
  }
  prepareParam(e, t) {
    let n;
    if (G.isRef(e))
      n = e;
    else {
      let s = this.cast(e);
      if (!this._typeCheck(s)) throw new TypeError(`\`${t}\` must be a Date or a value that can be \`cast()\` to a Date`);
      n = s;
    }
    return n;
  }
  min(e, t = ie.min) {
    let n = this.prepareParam(e, "min");
    return this.test({
      message: t,
      name: "min",
      exclusive: !0,
      params: {
        min: e
      },
      skipAbsent: !0,
      test(s) {
        return s >= this.resolve(n);
      }
    });
  }
  max(e, t = ie.max) {
    let n = this.prepareParam(e, "max");
    return this.test({
      message: t,
      name: "max",
      exclusive: !0,
      params: {
        max: e
      },
      skipAbsent: !0,
      test(s) {
        return s <= this.resolve(n);
      }
    });
  }
}
ce.INVALID_DATE = St;
function At(r, e = []) {
  let t = [], n = /* @__PURE__ */ new Set(), s = new Set(e.map(([a, u]) => `${a}-${u}`));
  function i(a, u) {
    let l = H.split(a)[0];
    n.add(l), s.has(`${u}-${l}`) || t.push([u, l]);
  }
  for (const a of Object.keys(r)) {
    let u = r[a];
    n.add(a), G.isRef(u) && u.isSibling ? i(u.path, a) : te(u) && "deps" in u && u.deps.forEach((l) => i(l, a));
  }
  return rt.array(Array.from(n), t).reverse();
}
function xe(r, e) {
  let t = 1 / 0;
  return r.some((n, s) => {
    var i;
    if ((i = e.path) != null && i.includes(n))
      return t = s, !0;
  }), t;
}
function qe(r) {
  return (e, t) => xe(r, e) - xe(r, t);
}
const Le = (r, e, t) => {
  if (typeof r != "string")
    return r;
  let n = r;
  try {
    n = JSON.parse(r);
  } catch {
  }
  return t.isType(n) ? n : r;
};
function Q(r) {
  if ("fields" in r) {
    const e = {};
    for (const [t, n] of Object.entries(r.fields))
      e[t] = Q(n);
    return r.setFields(e);
  }
  if (r.type === "array") {
    const e = r.optional();
    return e.innerType && (e.innerType = Q(e.innerType)), e;
  }
  return r.type === "tuple" ? r.optional().clone({
    types: r.spec.types.map(Q)
  }) : "optional" in r ? r.optional() : r;
}
const kt = (r, e) => {
  const t = [...H.normalizePath(e)];
  if (t.length === 1) return t[0] in r;
  let n = t.pop(), s = H.getter(H.join(t), !0)(r);
  return !!(s && n in s);
};
let _e = (r) => Object.prototype.toString.call(r) === "[object Object]";
function ve(r, e) {
  let t = Object.keys(r.fields);
  return Object.keys(e).filter((n) => t.indexOf(n) === -1);
}
const Rt = qe([]);
function k(r) {
  return new Ie(r);
}
class Ie extends M {
  constructor(e) {
    super({
      type: "object",
      check(t) {
        return _e(t) || typeof t == "function";
      }
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = Rt, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      e && this.shape(e);
    });
  }
  _cast(e, t = {}) {
    var n;
    let s = super._cast(e, t);
    if (s === void 0) return this.getDefault(t);
    if (!this._typeCheck(s)) return s;
    let i = this.fields, a = (n = t.stripUnknown) != null ? n : this.spec.noUnknown, u = [].concat(this._nodes, Object.keys(s).filter((d) => !this._nodes.includes(d))), l = {}, o = Object.assign({}, t, {
      parent: l,
      __validating: t.__validating || !1
    }), c = !1;
    for (const d of u) {
      let p = i[d], m = d in s;
      if (p) {
        let w, _ = s[d];
        o.path = (t.path ? `${t.path}.` : "") + d, p = p.resolve({
          value: _,
          context: t.context,
          parent: l
        });
        let S = p instanceof M ? p.spec : void 0, f = S == null ? void 0 : S.strict;
        if (S != null && S.strip) {
          c = c || d in s;
          continue;
        }
        w = !t.__validating || !f ? (
          // TODO: use _cast, this is double resolving
          p.cast(s[d], o)
        ) : s[d], w !== void 0 && (l[d] = w);
      } else m && !a && (l[d] = s[d]);
      (m !== d in l || l[d] !== s[d]) && (c = !0);
    }
    return c ? l : s;
  }
  _validate(e, t = {}, n, s) {
    let {
      from: i = [],
      originalValue: a = e,
      recursive: u = this.spec.recursive
    } = t;
    t.from = [{
      schema: this,
      value: a
    }, ...i], t.__validating = !0, t.originalValue = a, super._validate(e, t, n, (l, o) => {
      if (!u || !_e(o)) {
        s(l, o);
        return;
      }
      a = a || o;
      let c = [];
      for (let d of this._nodes) {
        let p = this.fields[d];
        !p || G.isRef(p) || c.push(p.asNestedTest({
          options: t,
          key: d,
          parent: o,
          parentPath: t.path,
          originalParent: a
        }));
      }
      this.runTests({
        tests: c,
        value: o,
        originalValue: a,
        options: t
      }, n, (d) => {
        s(d.sort(this._sortErrors).concat(l), o);
      });
    });
  }
  clone(e) {
    const t = super.clone(e);
    return t.fields = Object.assign({}, this.fields), t._nodes = this._nodes, t._excludedEdges = this._excludedEdges, t._sortErrors = this._sortErrors, t;
  }
  concat(e) {
    let t = super.concat(e), n = t.fields;
    for (let [s, i] of Object.entries(this.fields)) {
      const a = n[s];
      n[s] = a === void 0 ? i : a;
    }
    return t.withMutation((s) => (
      // XXX: excludes here is wrong
      s.setFields(n, [...this._excludedEdges, ...e._excludedEdges])
    ));
  }
  _getDefault(e) {
    if ("default" in this.spec)
      return super._getDefault(e);
    if (!this._nodes.length)
      return;
    let t = {};
    return this._nodes.forEach((n) => {
      var s;
      const i = this.fields[n];
      let a = e;
      (s = a) != null && s.value && (a = Object.assign({}, a, {
        parent: a.value,
        value: a.value[n]
      })), t[n] = i && "getDefault" in i ? i.getDefault(a) : void 0;
    }), t;
  }
  setFields(e, t) {
    let n = this.clone();
    return n.fields = e, n._nodes = At(e, t), n._sortErrors = qe(Object.keys(e)), t && (n._excludedEdges = t), n;
  }
  shape(e, t = []) {
    return this.clone().withMutation((n) => {
      let s = n._excludedEdges;
      return t.length && (Array.isArray(t[0]) || (t = [t]), s = [...n._excludedEdges, ...t]), n.setFields(Object.assign(n.fields, e), s);
    });
  }
  partial() {
    const e = {};
    for (const [t, n] of Object.entries(this.fields))
      e[t] = "optional" in n && n.optional instanceof Function ? n.optional() : n;
    return this.setFields(e);
  }
  deepPartial() {
    return Q(this);
  }
  pick(e) {
    const t = {};
    for (const n of e)
      this.fields[n] && (t[n] = this.fields[n]);
    return this.setFields(t, this._excludedEdges.filter(([n, s]) => e.includes(n) && e.includes(s)));
  }
  omit(e) {
    const t = [];
    for (const n of Object.keys(this.fields))
      e.includes(n) || t.push(n);
    return this.pick(t);
  }
  from(e, t, n) {
    let s = H.getter(e, !0);
    return this.transform((i) => {
      if (!i) return i;
      let a = i;
      return kt(i, e) && (a = Object.assign({}, i), n || delete a[e], a[t] = s(i)), a;
    });
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(Le);
  }
  /**
   * Similar to `noUnknown` but only validates that an object is the right shape without stripping the unknown keys
   */
  exact(e) {
    return this.test({
      name: "exact",
      exclusive: !0,
      message: e || X.exact,
      test(t) {
        if (t == null) return !0;
        const n = ve(this.schema, t);
        return n.length === 0 || this.createError({
          params: {
            properties: n.join(", ")
          }
        });
      }
    });
  }
  stripUnknown() {
    return this.clone({
      noUnknown: !0
    });
  }
  noUnknown(e = !0, t = X.noUnknown) {
    typeof e != "boolean" && (t = e, e = !0);
    let n = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: t,
      test(s) {
        if (s == null) return !0;
        const i = ve(this.schema, s);
        return !e || i.length === 0 || this.createError({
          params: {
            unknown: i.join(", ")
          }
        });
      }
    });
    return n.spec.noUnknown = e, n;
  }
  unknown(e = !0, t = X.noUnknown) {
    return this.noUnknown(!e, t);
  }
  transformKeys(e) {
    return this.transform((t) => {
      if (!t) return t;
      const n = {};
      for (const s of Object.keys(t)) n[e(s)] = t[s];
      return n;
    });
  }
  camelCase() {
    return this.transformKeys(se.camelCase);
  }
  snakeCase() {
    return this.transformKeys(se.snakeCase);
  }
  constantCase() {
    return this.transformKeys((e) => se.snakeCase(e).toUpperCase());
  }
  describe(e) {
    const t = (e ? this.resolve(e) : this).clone(), n = super.describe(e);
    n.fields = {};
    for (const [i, a] of Object.entries(t.fields)) {
      var s;
      let u = e;
      (s = u) != null && s.value && (u = Object.assign({}, u, {
        parent: u.value,
        value: u.value[i]
      })), n.fields[i] = a.describe(u);
    }
    return n;
  }
}
k.prototype = Ie.prototype;
function I(r) {
  return new Ve(r);
}
class Ve extends M {
  constructor(e) {
    super({
      type: "array",
      spec: {
        types: e
      },
      check(t) {
        return Array.isArray(t);
      }
    }), this.innerType = void 0, this.innerType = e;
  }
  _cast(e, t) {
    const n = super._cast(e, t);
    if (!this._typeCheck(n) || !this.innerType)
      return n;
    let s = !1;
    const i = n.map((a, u) => {
      const l = this.innerType.cast(a, Object.assign({}, t, {
        path: `${t.path || ""}[${u}]`
      }));
      return l !== a && (s = !0), l;
    });
    return s ? i : n;
  }
  _validate(e, t = {}, n, s) {
    var i;
    let a = this.innerType, u = (i = t.recursive) != null ? i : this.spec.recursive;
    t.originalValue != null && t.originalValue, super._validate(e, t, n, (l, o) => {
      var c;
      if (!u || !a || !this._typeCheck(o)) {
        s(l, o);
        return;
      }
      let d = new Array(o.length);
      for (let m = 0; m < o.length; m++) {
        var p;
        d[m] = a.asNestedTest({
          options: t,
          index: m,
          parent: o,
          parentPath: t.path,
          originalParent: (p = t.originalValue) != null ? p : e
        });
      }
      this.runTests({
        value: o,
        tests: d,
        originalValue: (c = t.originalValue) != null ? c : e,
        options: t
      }, n, (m) => s(m.concat(l), o));
    });
  }
  clone(e) {
    const t = super.clone(e);
    return t.innerType = this.innerType, t;
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(Le);
  }
  concat(e) {
    let t = super.concat(e);
    return t.innerType = this.innerType, e.innerType && (t.innerType = t.innerType ? (
      // @ts-expect-error Lazy doesn't have concat and will break
      t.innerType.concat(e.innerType)
    ) : e.innerType), t;
  }
  of(e) {
    let t = this.clone();
    if (!te(e)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + L(e));
    return t.innerType = e, t.spec = Object.assign({}, t.spec, {
      types: e
    }), t;
  }
  length(e, t = J.length) {
    return this.test({
      message: t,
      name: "length",
      exclusive: !0,
      params: {
        length: e
      },
      skipAbsent: !0,
      test(n) {
        return n.length === this.resolve(e);
      }
    });
  }
  min(e, t) {
    return t = t || J.min, this.test({
      message: t,
      name: "min",
      exclusive: !0,
      params: {
        min: e
      },
      skipAbsent: !0,
      // FIXME(ts): Array<typeof T>
      test(n) {
        return n.length >= this.resolve(e);
      }
    });
  }
  max(e, t) {
    return t = t || J.max, this.test({
      message: t,
      name: "max",
      exclusive: !0,
      params: {
        max: e
      },
      skipAbsent: !0,
      test(n) {
        return n.length <= this.resolve(e);
      }
    });
  }
  ensure() {
    return this.default(() => []).transform((e, t) => this._typeCheck(e) ? e : t == null ? [] : [].concat(t));
  }
  compact(e) {
    let t = e ? (n, s, i) => !e(n, s, i) : (n) => !!n;
    return this.transform((n) => n != null ? n.filter(t) : n);
  }
  describe(e) {
    const t = (e ? this.resolve(e) : this).clone(), n = super.describe(e);
    if (t.innerType) {
      var s;
      let i = e;
      (s = i) != null && s.value && (i = Object.assign({}, i, {
        parent: i.value,
        value: i.value[0]
      })), n.innerType = t.innerType.describe(i);
    }
    return n;
  }
}
I.prototype = Ve.prototype;
const Ot = k({
  lat: y().min(-90, "Must be a valid latitude.").max(90, "Must be a valid latitude.").when("geogId", {
    is: (r) => typeof r == "string",
    then: (r) => r.optional(),
    otherwise: (r) => r.required()
  }),
  lng: y().min(-180, "Must be a valid longitude.").max(180, "Must be a valid longitude.").when("geogId", {
    is: (r) => typeof r == "string",
    then: (r) => r.optional(),
    otherwise: (r) => r.required()
  }),
  geogId: b().optional(),
  include: b().oneOf(["geometry"]),
  externalId: b().optional()
}), Mt = (r) => async (e) => {
  const t = await Ot.validate(e), { lat: n, lng: s, geogId: i } = t, a = i ? `${he}/${i}` : he, u = {
    lat: n,
    lng: s,
    external_id: e == null ? void 0 : e.externalId
  };
  return e.include && (u.include = e.include), (await r.get(a, {
    params: u
  })).data;
};
var Ue = /* @__PURE__ */ ((r) => (r[r.measures_all = 0] = "measures_all", r[r.scores_all = 1] = "scores_all", r))(Ue || {});
const Nt = "/data", Dt = new RegExp(
  `(${Object.keys(Ue).filter((r) => Number.isNaN(Number(r))).join("|")})`
), jt = k({
  lat: y().min(-90, "Must be a valid latitude.").max(90, "Must be a valid latitude.").required(),
  lng: y().min(-180, "Must be a valid longitude.").max(180, "Must be a valid longitude.").required(),
  include: I().of(
    b().matches(Dt, "Must be a valid Data category.").required()
  ).required(),
  radius: y().max(5e3)
}), Ct = (r) => async (e) => {
  const t = await jt.validate(e), { lat: n, lng: s, radius: i, include: a } = t, u = await r.get(Nt, {
    params: {
      lat: n,
      lng: s,
      radius: i,
      include: a == null ? void 0 : a.join(",")
    }
  }), l = a.reduce(
    (o, c) => ({ ...o, [c]: [] }),
    {}
  );
  return u.data || l;
}, Ee = "/demographics", qt = k({
  lat: y().min(-90, "Must be a valid latitude.").max(90, "Must be a valid latitude.").optional(),
  lng: y().min(-180, "Must be a valid longitude.").max(180, "Must be a valid longitude.").optional(),
  geographyId: b().optional(),
  radius: y().max(5e3)
}), Lt = (r) => async (e) => {
  const t = await qt.validate(e), { lat: n, lng: s, geographyId: i, radius: a } = t, u = i ? `${Ee}/${i}` : Ee, o = { ...(await r.get(u, {
    params: {
      lat: n,
      lng: s,
      radius: a
    }
  })).data.attributes }, c = {
    inc_home: "avg_household_income",
    inc_person: "avg_individual_income",
    prop_renter: "renters",
    prop_owner: "owners"
  };
  return Object.prototype.hasOwnProperty.call(o, "income_stats") && o.income_stats && (o.income = {
    label: o.income_stats.label,
    type: o.income_stats.type,
    variables: o.income_stats.variables.map((d) => ({
      ...d,
      variable: c[d.variable]
    }))
  }), Object.prototype.hasOwnProperty.call(
    o,
    "property_tenure"
  ) && o.property_tenure && (o.housing_tenancy = {
    label: o.property_tenure.label,
    type: o.property_tenure.type,
    variables: o.property_tenure.variables.map((d) => ({
      ...d,
      variable: c[d.variable]
    }))
  }), o;
}, It = "/enhanced_pois";
var h = /* @__PURE__ */ ((r) => (r.ALCOHOL = "alcohol", r.ART_CULTURE_SCIENCE = "art_culture_science", r.BUS_STOPS = "bus_stops", r.CAFES = "cafes", r.CAR_FUELING_STATIONS = "car_fueling_stations", r.CLOTHING = "clothing", r.COMMON_NEEDS = "common_needs", r.CONFERENCE_CENTERS = "conference_centers", r.DAYCARES = "daycares", r.ENTERTAINMENT = "entertainment", r.FITNESS = "fitness", r.GROCERIES_SPECIALIZED = "groceries_specialized", r.GROCERIES = "groceries", r.HEALTH_CARE = "health_care", r.HOME_IMPROVEMENT = "home_improvement", r.HOSPITALS = "hospitals", r.LIBRARIES = "libraries", r.NIGHTLIFE = "nightlife", r.PARKS = "parks", r.PERSONAL_CARE = "personal_care", r.PET_CARE = "pet_care", r.PHARMACIES = "pharmacies", r.RAPID_TRANSIT_STATIONS = "rapid_transit_stations", r.RESTAURANTS = "restaurants", r.RETAIL = "retail", r.SHOPS_AND_SERVICES = "shops_and_services", r.SPORT_FACILITIES = "sport_facilities", r.TRAIN_STATIONS = "train_stations", r))(h || {});
const Vt = new RegExp(
  `(${Object.keys(h).filter((r) => Number.isNaN(Number(r))).join("|")})`
), Ut = k({
  lat: y().min(-90, "Must be a valid latitude.").max(90, "Must be a valid latitude.").required(),
  lng: y().min(-180, "Must be a valid longitude.").max(180, "Must be a valid longitude.").required(),
  limit: y().max(500),
  radius: y().max(25e3),
  include: I().of(
    b().matches(Vt, "Must be a valid Score category.").required()
  )
}), zt = (r) => async (e) => {
  const t = await Ut.validate(e), { include: n, lat: s, lng: i, limit: a, radius: u } = t;
  return await r.get(It, {
    params: {
      categories: n == null ? void 0 : n.join(","),
      lat: s,
      lng: i,
      limit: a,
      radius: u
    }
  }) || {
    results: [],
    meta: {
      message: "Successfully called v3/enhanced_pois API.",
      type: "LocalLogic.API.Success",
      statusCode: 200,
      counts: {
        returned_count: 0,
        total_count: 0,
        returned_by_category: {
          [h.ALCOHOL]: 0,
          [h.ART_CULTURE_SCIENCE]: 0,
          [h.CAFES]: 0,
          [h.CAR_FUELING_STATIONS]: 0,
          [h.CLOTHING]: 0,
          [h.COMMON_NEEDS]: 0,
          [h.CONFERENCE_CENTERS]: 0,
          [h.DAYCARES]: 0,
          [h.ENTERTAINMENT]: 0,
          [h.FITNESS]: 0,
          [h.GROCERIES_SPECIALIZED]: 0,
          [h.GROCERIES]: 0,
          [h.HEALTH_CARE]: 0,
          [h.HOME_IMPROVEMENT]: 0,
          [h.HOSPITALS]: 0,
          [h.LIBRARIES]: 0,
          [h.NIGHTLIFE]: 0,
          [h.PERSONAL_CARE]: 0,
          [h.PET_CARE]: 0,
          [h.PHARMACIES]: 0,
          [h.RESTAURANTS]: 0,
          [h.RETAIL]: 0,
          [h.SHOPS_AND_SERVICES]: 0,
          [h.SPORT_FACILITIES]: 0
        },
        total_by_category: {
          [h.ALCOHOL]: 0,
          [h.ART_CULTURE_SCIENCE]: 0,
          [h.CAFES]: 0,
          [h.CAR_FUELING_STATIONS]: 0,
          [h.CLOTHING]: 0,
          [h.COMMON_NEEDS]: 0,
          [h.CONFERENCE_CENTERS]: 0,
          [h.DAYCARES]: 0,
          [h.ENTERTAINMENT]: 0,
          [h.FITNESS]: 0,
          [h.GROCERIES_SPECIALIZED]: 0,
          [h.GROCERIES]: 0,
          [h.HEALTH_CARE]: 0,
          [h.HOME_IMPROVEMENT]: 0,
          [h.HOSPITALS]: 0,
          [h.LIBRARIES]: 0,
          [h.NIGHTLIFE]: 0,
          [h.PERSONAL_CARE]: 0,
          [h.PET_CARE]: 0,
          [h.PHARMACIES]: 0,
          [h.RESTAURANTS]: 0,
          [h.RETAIL]: 0,
          [h.SHOPS_AND_SERVICES]: 0,
          [h.SPORT_FACILITIES]: 0
        }
      }
    }
  };
}, Ht = "/location", Gt = k({
  lat: y().min(-90, "Must be a valid latitude.").max(90, "Must be a valid latitude.").required(),
  lng: y().min(-180, "Must be a valid longitude.").max(180, "Must be a valid longitude.").required()
}), Zt = (r) => async (e) => {
  const t = await Gt.validate(e), { lat: n, lng: s } = t;
  return (await r.get(Ht, {
    params: {
      lat: n,
      lng: s
    }
  })).data;
};
var ze = /* @__PURE__ */ ((r) => (r[r.groceries = 0] = "groceries", r[r.groceries_specialized = 1] = "groceries_specialized", r[r.shopping = 2] = "shopping", r[r.nightlife = 3] = "nightlife", r[r.restaurants = 4] = "restaurants", r[r.cafes = 5] = "cafes", r[r.daycares = 6] = "daycares", r[r.bus_stops = 7] = "bus_stops", r[r.rapid_transit_stations = 8] = "rapid_transit_stations", r[r.train_stations = 9] = "train_stations", r[r.parks = 10] = "parks", r[r.healthy_restaurants = 11] = "healthy_restaurants", r[r.fitness = 12] = "fitness", r[r.sport_facilities = 13] = "sport_facilities", r[r.health_care = 14] = "health_care", r[r.pet_care = 15] = "pet_care", r[r.car_fueling_stations = 16] = "car_fueling_stations", r[r.art_culture_science = 17] = "art_culture_science", r[r.home_improvement = 18] = "home_improvement", r[r.personal_care = 19] = "personal_care", r))(ze || {});
const le = "/pois", Pt = new RegExp(
  `(${Object.keys(ze).filter((r) => Number.isNaN(Number(r))).join("|")})`
), He = k({
  lat: y().min(-90, "Must be a valid latitude.").max(90, "Must be a valid latitude.").required(),
  lng: y().min(-180, "Must be a valid longitude.").max(180, "Must be a valid longitude.").required(),
  limit: y().max(500),
  attemptMinimum: y().max(30),
  radius: y().max(25e3),
  include: I().of(
    b().matches(Pt, "Must be a valid Score category.").required()
  ).required()
});
function Ge(r, e) {
  if (!r)
    return !1;
  let t = 0;
  return Object.values(r).forEach((n) => {
    t += (n == null ? void 0 : n.length) || 0;
  }), t >= e;
}
const Bt = (r) => async (e) => {
  const t = await He.validate(e), { lat: n, lng: s, limit: i = 30, attemptMinimum: a, radius: u, include: l } = t;
  let o = await r.get(le, {
    params: {
      lat: n,
      lng: s,
      // 30 is the max for querying multiple categories
      limit: l.length > 1 && i > 30 ? 30 : i,
      radius: u,
      include: l == null ? void 0 : l.join(",")
    }
  });
  typeof a < "u" && !Ge((o == null ? void 0 : o.data) || null, a) && (o = await r.get(le, {
    params: {
      lat: n,
      lng: s,
      limit: a,
      radius: 1e4,
      // Max is 25km
      include: l == null ? void 0 : l.join(",")
    }
  }));
  const c = l.reduce(
    (d, p) => ({ ...d, [p]: [] }),
    {}
  );
  return o.data || c;
}, Yt = (r) => async (e) => {
  const t = await He.validate(e), { lat: n, lng: s, limit: i, radius: a, include: u } = t, l = await r.get(le, {
    params: {
      lat: n,
      lng: s,
      limit: i,
      radius: a,
      include: u == null ? void 0 : u.join(",")
    }
  }), o = u.reduce(
    (c, d) => ({ ...c, [d]: 0 }),
    {}
  );
  return l.meta.counts || o;
}, we = "/profiles", Kt = k({
  lat: y().min(-90, "Must be a valid latitude.").max(90, "Must be a valid latitude.").when("geogId", {
    is: (r) => typeof r == "string",
    then: (r) => r.optional(),
    otherwise: (r) => r.required()
  }),
  lng: y().min(-180, "Must be a valid longitude.").max(180, "Must be a valid longitude.").when("geogId", {
    is: (r) => typeof r == "string",
    then: (r) => r.optional(),
    otherwise: (r) => r.required()
  }),
  geogId: b().optional(),
  externalId: b().optional()
}), Xt = (r) => async (e) => {
  const t = await Kt.validate(e), { lat: n, lng: s, geogId: i } = t, a = i ? `${we}/${i}` : we;
  return (await r.get(a, {
    params: {
      lat: n,
      lng: s,
      external_id: e == null ? void 0 : e.externalId
    }
  })).data;
};
var Ze = /* @__PURE__ */ ((r) => (r[r.pedestrian_friendly = 0] = "pedestrian_friendly", r[r.cycling_friendly = 1] = "cycling_friendly", r[r.transit_friendly = 2] = "transit_friendly", r[r.car_friendly = 3] = "car_friendly", r[r.parks = 4] = "parks", r[r.groceries = 5] = "groceries", r[r.shopping = 6] = "shopping", r[r.nightlife = 7] = "nightlife", r[r.restaurants = 8] = "restaurants", r[r.cafes = 9] = "cafes", r[r.daycares = 10] = "daycares", r[r.primary_schools = 11] = "primary_schools", r[r.high_schools = 12] = "high_schools", r[r.quiet = 13] = "quiet", r[r.greenery = 14] = "greenery", r[r.historic = 15] = "historic", r[r.vibrant = 16] = "vibrant", r[r.wellness = 17] = "wellness", r))(Ze || {});
const Jt = "/scores", Qt = new RegExp(
  `(${Object.keys(Ze).filter((r) => Number.isNaN(Number(r))).join("|")})`
), Wt = k({
  lat: y().min(-90, "Must be a valid latitude.").max(90, "Must be a valid latitude."),
  lng: y().min(-180, "Must be a valid longitude.").max(180, "Must be a valid longitude."),
  geographyIds: I().of(b().required()),
  geographyLevels: I().of(
    b().matches(/10|20|30/, "Must be a valid Geography level.").required()
  ),
  locationScoresRounding: oe(),
  include: I().of(
    b().matches(Qt, "Must be a valid Score category.").required()
  )
}), er = (r) => async (e) => {
  const t = await Wt.validate(e), {
    lat: n,
    lng: s,
    include: i,
    geographyIds: a,
    geographyLevels: u,
    locationScoresRounding: l = !0
  } = t;
  return (await r.get(Jt, {
    params: {
      lat: n,
      lng: s,
      include: i == null ? void 0 : i.join(","),
      geography_levels: u == null ? void 0 : u.join(","),
      geography_ids: a == null ? void 0 : a.join(","),
      location_scores_rounding: l ? ".5" : "none"
    }
  })).data;
}, tr = "/similar-neighborhoods", rr = k({
  lat: y().min(-90, "Must be a valid latitude.").max(90, "Must be a valid latitude."),
  lng: y().min(-180, "Must be a valid longitude.").max(180, "Must be a valid longitude."),
  geogId: b(),
  limit: y().positive(),
  externalId: b().optional()
}), nr = (r) => async (e) => {
  const t = await rr.validate(e), { lat: n, lng: s, geogId: i, limit: a } = t, u = await r.get(
    `${tr}/${i}`,
    {
      params: {
        lat: n,
        lng: s,
        limit: a,
        external_id: e == null ? void 0 : e.externalId
      }
    }
  );
  return u != null && u.data ? u.data : {
    id: i,
    most_similar: []
  };
}, sr = "/value-drivers", ir = k({
  geogId: b().required(),
  limit: y().optional()
}), ar = (r) => async (e) => {
  const t = await ir.validate(e), { geogId: n } = t, s = await r.get(
    `${sr}/${n}`,
    {
      params: {
        limit: e.limit || -1
      }
    }
  ), i = s.data.value_drivers.map(
    (a) => ({
      ...a,
      name: (a.name || "").toLocaleLowerCase(),
      value_qualifier: (a.value_qualifier || "").toLocaleLowerCase()
    })
  );
  return {
    ...s.data,
    value_drivers: i
  };
}, Te = "/schools", ur = k({
  lat: y().min(-90, "Must be a valid latitude.").max(90, "Must be a valid latitude.").required(),
  lng: y().min(-180, "Must be a valid longitude.").max(180, "Must be a valid longitude.").required(),
  limit: y().max(30, "Must use a limit between 1 and 30."),
  attemptMinimum: y().max(30),
  radius: y().max(25e3, "Must use a radius between 1 and 25000."),
  include_catchments: oe()
}), lr = (r) => async (e) => {
  const t = await ur.validate(e), {
    lat: n,
    lng: s,
    limit: i,
    attemptMinimum: a,
    radius: u,
    // eslint-disable-next-line camelcase
    include_catchments: l
  } = t;
  let o = await r.get(Te, {
    params: {
      lat: n,
      lng: s,
      limit: i,
      radius: u,
      // eslint-disable-next-line camelcase
      include_catchments: l
    }
  });
  return typeof a < "u" && !Ge((o == null ? void 0 : o.data) || null, a) && (o = await r.get(Te, {
    params: {
      lat: n,
      lng: s,
      limit: a,
      radius: 1e4,
      // Max is 25km
      // eslint-disable-next-line camelcase
      include_catchments: l
    }
  })), o.data;
}, or = "/marketstats", cr = k({
  geogId: b().required()
}), dr = (r) => async (e) => {
  const t = await cr.validate(e), { geogId: n } = t;
  return (await r.get(
    `${or}/${n}`
  )).data;
}, fr = "/market-stats", hr = k({
  geogId: b().required(),
  intervals: I().of(b().required()),
  propertyTypes: I().of(b().required())
}), pr = (r) => async (e) => {
  const t = await hr.validate(e), { geogId: n, propertyTypes: s, intervals: i } = t;
  return (await r.get(
    `${fr}/${n}`,
    {
      params: {
        property_types: s == null ? void 0 : s.join(","),
        intervals: i == null ? void 0 : i.join(",")
      }
    }
  )).data;
}, Pe = "LocalLogicClient/";
class Be extends Error {
  constructor({ message: e }) {
    super(e), this.name = Pe + this.constructor.name;
  }
}
class Ye extends Error {
  constructor({ message: e }) {
    super(e), this.name = Pe + this.constructor.name;
  }
}
const $e = (r) => {
  throw r instanceof A ? new Be(r) : new Ye(r);
}, R = (r, e, t) => {
  const n = t.value;
  return t.value = function(...s) {
    try {
      const i = n.apply(this, s);
      return i && i instanceof Promise ? i.catch((a) => {
        $e(a);
      }) : i;
    } catch (i) {
      $e(i);
    }
  }, t;
}, gr = (r) => r instanceof Be, br = (r) => r instanceof Ye;
var mr = Object.defineProperty, yr = Object.getOwnPropertyDescriptor, O = (r, e, t, n) => {
  for (var s = yr(e, t), i = r.length - 1, a; i >= 0; i--)
    (a = r[i]) && (s = a(e, t, s) || s);
  return s && mr(e, t, s), s;
};
class $ {
  constructor(e, t = { locale: "en" }) {
    this.requests = Xe(e, t), this.options = t;
  }
  getLocation(e) {
    return Zt(this.requests)(e);
  }
  getPois(e) {
    return Bt(this.requests)(e);
  }
  getPoisMetadata(e) {
    return Yt(this.requests)(e);
  }
  getScores(e) {
    return er(this.requests)(e);
  }
  getSimilarNeighborhoods(e) {
    return nr(this.requests)(e);
  }
  getSchools(e) {
    return lr(this.requests)(e);
  }
  getProfiles(e) {
    return Xt(this.requests)(e);
  }
  getGeographies(e) {
    return Mt(this.requests)(e);
  }
  getDemographics(e) {
    return Lt(this.requests)(e);
  }
  getData(e) {
    return Ct(this.requests)(e);
  }
  getEnhancedPois(e) {
    return zt(this.requests)(e);
  }
  getPropertyValueDrivers(e) {
    return ar(this.requests)(e);
  }
  getMarketTrends(e) {
    return dr(this.requests)(e);
  }
  getMarketActivity(e) {
    return pr(this.requests)(e);
  }
}
O([
  R
], $.prototype, "getLocation");
O([
  R
], $.prototype, "getPois");
O([
  R
], $.prototype, "getPoisMetadata");
O([
  R
], $.prototype, "getScores");
O([
  R
], $.prototype, "getSimilarNeighborhoods");
O([
  R
], $.prototype, "getSchools");
O([
  R
], $.prototype, "getProfiles");
O([
  R
], $.prototype, "getGeographies");
O([
  R
], $.prototype, "getDemographics");
O([
  R
], $.prototype, "getData");
O([
  R
], $.prototype, "getEnhancedPois");
O([
  R
], $.prototype, "getPropertyValueDrivers");
O([
  R
], $.prototype, "getMarketTrends");
O([
  R
], $.prototype, "getMarketActivity");
const xr = (r, e) => new $(r, e);
export {
  Ue as DataCategories,
  h as EnhancedPOICategories,
  $ as Methods,
  ze as POICategories,
  Ze as ScoreNames,
  xr as default,
  br as isUnknownError,
  gr as isValidationError
};
